<script>
import LoadingDots from '@/components/LoadingDots'
import RequestRelay from '@/services/requestRelay'
import FileReaderUtils from '@/utils/fileReaderUtils'

export default
{
    name: 'profile-picture',

    props:
    {
        src: { type: String, required: true }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='profile-picture' on-click={this.onProfilePictureClicked}>
            {
                this.profilePictureElement
            }
            </div>
        )
    },

    mounted ()
    {
        this.refreshProfilePictureData()
    },

    data () 
    {
        return {
            profilePictureData: '',
            profilePictureElement: <div>lol</div>
        }
    },

    computed:
    {
        profilePictureUrl ()
        {
            var profilePictureUrl = this.src
            
            // does not allow cross origin requests, so can't tweak the avatar if not using a relay
            const useRelay = profilePictureUrl.includes('avataaars.io')
            
            return useRelay
                ? RequestRelay.get({ requestUrl: profilePictureUrl, cacheControl: 'max-age=' + 60 * 60 * 24 * 10, returnRequestUrlOnly: true })
                : profilePictureUrl
        }
    },

    watch:
    {
        src ()
        {
            this.refreshProfilePictureData()
        }
    },

    methods:
    {
        async refreshProfilePictureData ()
        {
            console.log('Refreshing profile picture with', this.profilePictureUrl)
            this.profilePictureElement = <loading-dots />

            const res = await FileReaderUtils.srcToBlobAsync(this.profilePictureUrl)

            if (!res) return
            
            if (res.type.includes('svg'))
            {
                var data = await FileReaderUtils.readAsTextAsync(res)

                this.profilePictureElement = <div domPropsInnerHTML={data} />
            }
            else
            {
                this.profilePictureElement = <img src={this.profilePictureUrl} />
            }
        },

        async onProfilePictureClicked ()
        {
            this.$emit('click')
        },
    },

    components:
    {
        LoadingDots
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.profile-picture
{
    .WidthHeight(100%);
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    cursor: pointer;

    svg
    {
        .WidthHeight(100%);
        
        #Color\/Palette\/Blue-01
        {
            fill: var(--theme-border-color-light) !important;
        }
    }

    img
    {
        .WidthHeight(100%);
        border-radius: 50%;
        object-fit: cover;
    }

    .loading-dots
    {
        background: var(--theme-border-color-light);
        border-radius: 50%;
        .WidthHeight(145.5px);
        margin-bottom: 4px;

        svg
        {
            width: 75%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ProfilePicture.vue